export default axios => ({
    getList(user) {
        return axios.get(`/membership/${user}`)
    },
    getByProcedure(user, procedure) {
        return axios.get(`/membership/${user}/procedure/${procedure}`)
    },
    getHistoryList(user, payload) {
        return axios.get(`/membership/${user}/archive`, payload)
    },
    create(user, payload) {
        return axios.post(`/membership/add/${user}`, payload)
    },
    update(user, membership, payload) {
        return axios.post(`membership/${user}/${membership}`, payload)
    }
})
